"use strict";
/**
 *  Module  领域热点详情页路由
 *  CreatyBy  陈浩
 * Description
 */
angular.module('PlanHotHeadLineRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
           .state('front.plan.hotfocus.hotpointdetail', { //热点详情页
                url: '/hotpointdetail?clusterid',
                views: {
                    'main@front.plan.hotfocus': {
                        templateUrl: './planningCenter/hotFocus/fieldHotSpots/hotHeadline/hotPointDetail/hotPointDetail_tpl.html',
                        controller: 'planHotPointDetailCtrl'
                    }
                }
            }).state('front.plan.hotfocus.searchlist', {
                url: '/searchlist?clusterid&entityfield&keyword&menutype&type&serviceid',
                views: {
                    'main@front.plan.hotfocus': {
                        templateUrl: './planningCenter/cueSelectedTopic/hotHeadLine/searchList/searchList_tpl.html',
                        controller: 'hotSearchListCtrl'
                    }
                }
            });
    }]);
